<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{
                  classification.id
                    ? $t("classification.form.titleEdit")
                    : $t("classification.form.titleNew")
                }}
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span>
                        {{ $t("classification.form.colorLabel") }}
                      </label>
                      <input
                        autocomplete="new-password"
                        type="color"
                        id="Name"
                        class="form-control"
                        v-model="classification.color"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span>
                        {{ $t("classification.form.companyLabel") }}
                      </label>
                      <v-select
                        :options="companies"
                        :reduce="(companies) => companies.id"
                        :label="'name'"
                        v-model="classification.tenancy_id"
                        class="vselect"
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span>
                        {{ $t("classification.form.statusLabel") }}
                      </label>
                      <select
                        v-model="classification.status"
                        class="form-control"
                      >
                        <option :value="1">{{ $t("common.active") }}</option>
                        <option :value="0">{{ $t("common.inactive") }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="Name">
                        <span class="required">*</span>
                        {{ $t("classification.form.descriptionLabel") }}
                      </label>
                      <textarea
                        class="form-control"
                        cols="30"
                        rows="3"
                        v-model="classification.description"
                      ></textarea>
                    </div>
                  </div>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>{{ $t("classification.form.requiredFields") }}</strong>
                  </span>
                  <div class="block text-right">
                    <router-link
                      to="/classifications"
                      class="btn btn-back mr-1"
                    >
                      <i class="fa fa-arrow-left"></i> {{ $t("common.back") }}
                    </router-link>
                    <a v-if="$hasAbility('node.admin')" class="btn btn-add" @click="save">
                      {{ $t("common.save") }}
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";

export default {
  data() {
    return {
      classification: {
        color: "#000000",
        tenancy_id: "",
        description: "",
        status: "1",
      },
      companies: [],
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "classifications";

      if (self.classification.id) {
        self.classification._method = "PUT";
        api += "/" + self.classification.id;
      }

      self.$loading(true);

      axios
        .post(api, self.classification)
        .then((response) => {
          self.$message(
            self.$t("classification.messages.saveSuccessTitle"),
            self.$t("classification.messages.saveSuccessMessage"),
            "success"
          );
          self.$loading(false);
          this.$router.push("/classifications");
        })

        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function () {
      const self = this;
      let api = self.$store.state.api + "companies?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getClassification: function (id) {
      const self = this;
      const api = self.$store.state.api + "classifications/" + id;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.classification = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getCompanies();

    let id = self.$route.params.id;
    if (id) {
      self.getClassification(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>